import React from "react";
import { Star } from "lucide-react";

const REVIEWS = [
  {
    name: "Jiří Hanuš",
    quote:
      "Naprosto profesionální přístup a perfektně odvedená práce. Firma Sanvioro nám uklízela kanceláře a výsledek předčil očekávání. Všude čisto, spolehlivost, dochvilnost a skvělá komunikace. Určitě doporučuji každému, kdo hledá kvalitní úklidové služby.",
  },
  {
    name: "Monika Bartoňková",
    quote:
      "Děkuji za skvěle uklizenou kancelář. Rychlost i domluva naprosto skvělá. Děkuji ještě jednou.",
  },
  {
    name: "Kevin Trong",
    quote:
      "Úklid kanceláří a skladových prostor na jedničku. Doporučuji.",
  },
];

// Inline Google "G" mark — official 4-color glyph as SVG (used here only as
// a small attribution icon next to the "Ověřeno na Google" badge, sized 14px).
const GoogleGlyph = ({ size = 14 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    aria-hidden="true"
  >
    <path
      fill="#4285F4"
      d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
    />
    <path
      fill="#34A853"
      d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
    />
    <path
      fill="#FBBC05"
      d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
    />
    <path
      fill="#EA4335"
      d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
    />
  </svg>
);

const Stars = () => (
  <div
    className="flex items-center gap-0.5"
    role="img"
    aria-label="Hodnocení 5 z 5"
  >
    {[0, 1, 2, 3, 4].map((i) => (
      <Star
        key={i}
        size={16}
        strokeWidth={0}
        fill="#FBBC04"
        className="text-[#FBBC04]"
      />
    ))}
  </div>
);

const Reviews = () => {
  return (
    <section
      id="reference"
      data-testid="reviews-section"
      className="relative bg-white py-20 md:py-28 border-t border-[#E5E5E5]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-16">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.28em] font-bold text-[#0F5C69]">
              [ 04 ] — Reference
            </div>
            <h2 className="font-display text-4xl md:text-6xl font-bold tracking-[-0.025em] leading-[1.02] mt-5">
              Co o nás<br />říkají klienti.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {REVIEWS.map((r, i) => (
            <article
              key={r.name}
              data-testid={`review-card-${i}`}
              className="group relative bg-white border border-[#E5E5E5] rounded-2xl p-7 md:p-8 flex flex-col hover:border-[#0F5C69] transition-colors"
            >
              <div className="flex items-center gap-2.5">
                <span className="inline-flex shrink-0 transition-transform duration-200 ease-out motion-safe:[@media(hover:hover)]:group-hover:scale-110">
                  <GoogleGlyph size={24} />
                </span>
                <span className="text-[11px] uppercase tracking-[0.18em] font-bold text-[#555555]">
                  Ověřeno na Google
                </span>
              </div>

              <h3 className="mt-5 font-display text-lg md:text-xl font-bold tracking-tight text-[#111111]">
                {r.name}
              </h3>

              <div className="mt-2">
                <Stars />
              </div>

              <p className="mt-5 text-[15px] text-[#333333] leading-relaxed">
                „{r.quote}"
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
